import { Box } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { MailIconSharp } from '../CustomSVGIcons/MailIconSharp';
import { OTPOption } from '../EsOtpOptions/OTPOption';
import { EsFormWrapper } from './EsFormWrapper';
import { MessageIconSharp } from '../CustomSVGIcons/MessageIconSharp';
import { WhatsappIconOutline } from '../CustomSVGIcons/WhatsappIconOutline';
import React, { useState } from 'react';

interface IEsEnterOtp {
    title?: string;
    subtitle?: string;
    sx?: React.CSSProperties;
    phoneNumber: string;
    email: string;
    onSetOTPPreference: (val: 'sms' | 'whatsapp' | 'audme-app' | 'email') => void;
}

// Mask email: keep first 2 characters and domain
const maskEmail = (email: string): string => {
    const [name, domain] = email.split('@');
    if (!name || !domain) return email;
    const visible = name.slice(0, 2);
    return `${visible}${'*'.repeat(Math.max(name.length - 2, 3))}@${domain}`;
};

// Mask phone: keep first 4 and last 3 digits
const maskPhone = (phone: string): string => {
    const visibleStart = phone.slice(0, 4);
    const visibleEnd = phone.slice(-3);
    const maskedMiddle = '*'.repeat(Math.max(phone.length - 7, 4));
    return `${visibleStart}${maskedMiddle}${visibleEnd}`;
};

const OTPPage: React.FC<IEsEnterOtp> = ({ title, subtitle, sx, phoneNumber, email, onSetOTPPreference }) => {
    const { themeStyle } = useThemeContext();
    const maskedPhone = maskPhone(phoneNumber);
    const maskedEmail = maskEmail(email);
    const [selectedOTP, setSelectedOTP] = useState('');

    const handleSetOTP = (val: 'sms' | 'whatsapp' | 'audme-app' | 'email') => {
        setSelectedOTP(val);
        onSetOTPPreference(val);
    };

    return (
        <EsFormWrapper title={title || ''} text={subtitle || ''}>
            <Box sx={{ my: 3, width: '100%', ...sx }}>
                <OTPOption
                    type="email"
                    info={maskedEmail}
                    onClick={() => handleSetOTP('email')}
                    selected={selectedOTP === 'email'}
                    disabled
                    startIcon={
                        <MailIconSharp
                            style={{
                                width: '1.8em',
                                height: '1.8em',
                                color: theme[themeStyle].tag_white,
                                backgroundColor: theme[themeStyle].grey,
                                padding: 5,
                                borderRadius: 50,
                            }}
                        />
                    }
                />
                <OTPOption
                    type="sms"
                    info={maskedPhone}
                    selected={selectedOTP === 'sms'}
                    onClick={() => handleSetOTP('sms')}
                    startIcon={
                        <MessageIconSharp
                            style={{
                                width: '1.8em',
                                height: '1.8em',
                                color: theme[themeStyle].tag_white,
                                backgroundColor: theme[themeStyle].grey,
                                padding: 5,
                                borderRadius: 50,
                            }}
                        />
                    }
                />
                <OTPOption
                    type="whatsapp"
                    info={maskedPhone}
                    selected={selectedOTP === 'whatsapp'}
                    onClick={() => handleSetOTP('whatsapp')}
                    startIcon={
                        <WhatsappIconOutline
                            style={{
                                width: '1.8em',
                                height: '1.8em',
                                color: theme[themeStyle].tag_white,
                                backgroundColor: theme[themeStyle].grey,
                                padding: 5,
                                borderRadius: 50,
                            }}
                        />
                    }
                />
            </Box>
        </EsFormWrapper>
    );
};

export { OTPPage };
